exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout-desktop__right[data-v-2343db1c] {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  position: sticky;\n  top: var(--size-lg);\n}\n.checkout-desktop__right > *[data-v-2343db1c]:not(:last-child) {\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--gray-200);\n}", ""]);

// exports
